export default {
    routesInfos: {
        modalText: 'Please choose the language you prefer:',
        modalGreek: 'ΕΛΛΗΝΙΚΑ',
        modalEnglish: 'ENGLISH',
        station: 'STATION',
        routes: 'ROUTES',
        company: 'COMPANY',
        train: 'TRAIN',
        destinations: 'FROM - TO',
        gate: 'GATE',
        arrival: 'ARRIVAL',
        departure: 'DEPARTURE',
        start: 'START',
        delay: 'DELAY',
        social: 'FIND US ON SOCIAL MEDIA',
        loading: 'LOADING...',
        noData: 'No routes available'
    }
}
